<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import configs from '../../config';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faRotateRight,faPlay,faSpinner,faCrown,faHandHoldingDollar,faMoneyBills } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    import Time from "svelte-time";

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let isList=  false
    let isError = false


    let cashbackLoglist = []
    let dataranking={
        rank_credit:0,
        rank_point:0
    }
    let checkRank = false
    let myPoint = 0
    let checkList = false
    let wheelgameList = []
    let member_url = ""
    async function getranking() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/luckywheelrank", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            dataranking.rank_credit = json.payload.rank_credit
            dataranking.rank_point = json.payload.rank_point
           // dataranking = JSON.parse(dataranking)
            
            checkRank = true
            gethistory()
            getwheelgamelist()
            getmyranking()
		} else {
            throw new Error(json);
		}
    }
    async function getmyranking() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmyranking", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            myPoint = json.payload.point
		} else {
            throw new Error(json);
		}
    }
    async function getwheelgamelist() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getwheelgamelist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            wheelgameList = json.payload
            checkList = true

            let dataxSetting = window.localStorage.getItem("setting")
            let vxSetting = JSON.parse(dataxSetting)
            member_url = vxSetting.member_url
		} else {
            throw new Error(json);
		}
    }
    async function gethistory() {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/luckywheelhistory", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            cashbackLoglist = json.payload
                isList = true
                isError = false
		} else {
            throw new Error(json);
		}
    }
    async function buyspin(dataid) {
        let couponx = ""
        Swal.fire({
            title: "กรุณาระบุจำนวน spin",
            input: "text",
            inputAttributes: {
                autocapitalize: "off",
                align: "center"
            },
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
            preConfirm: async (login) => {
                try {
                    couponx = login
                    const res = await fetch(window.localStorage.getItem("apiurl")+"member/buyspingame", {
                        method: 'POST',
                        headers:{
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                            'x-api-appid': window.localStorage.getItem("appid")
                        },
                        body: qs.stringify({
                            id:dataid,
                            spin:login
                        })
                    })
                    const json = await res.json()
                    return json
                } catch (error) {
                    Swal.showValidationMessage(`
                        Request failed: ${error}
                    `);
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            
            if (result.isConfirmed) {
                // Swal.fire({
                // title: `${result.value.login}'s avatar`,
                // imageUrl: result.value.avatar_url
                // });
                if(result.value.statusCode == 200){
                    getranking()
                }else{
                    Swal.fire(result.value.message)
                }
            }else{
                
            }
        });
    }

    $: {
        getranking()
        // getmyranking()
        
    }
    
</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><h4 class="header-n">กงล้อเสี่ยงโชค</h4></div>
    <div class="col-12" style="min-height: 500px;">
        <div class="col-12 mt-4" style="text-align: center;">
            <div class="card bg-black mb-2 pt-3 pb-3">
                <div class="col-12 text-center"><h6 class="text-white">คุณมี Point คงเหลือ <b style="color: gold;">{myPoint.toLocaleString("en-US")}</b> Point</h6></div>
            </div>
        </div>
        <div class="col-12 mt-2 mb-2" style="text-align: center;">
            <div class="card bg-black"  style="text-align: center;justify-content: center;align-items: center;    background-color: transparent !important;border: 0px;">
                {#if checkRank}
                    {#if checkList}
                    <div class="row">
                        {#each wheelgameList as prs}
                        <div class="col-12 text-cemter p-1">
                            
                            <div class="card bg-black p-2 text-center">
                                <h5 class="text-white">{prs.campaign.campaign_name}</h5>
                                <img src="{prs.campaign.campaign_img}" class="img-fluid" />
                                <h5 class="text-white">คุณมี <b class="text-warning">{prs.spin}</b> spin</h5>
                                <div class="row">
                                    <div class="col-6 ps-3">
                                        
                                        <img src="./assets/images/buyspin.png" class="img-fluid pointer" on:click={() => buyspin(prs.campaign._id)}>
                                        
                                    </div>
                                    
                                    <div class="col-6 pe-3">
                                        <a href="{member_url}/luckywheel?id={prs.campaign._id}" target="_blank">
                                        <img src="./assets/images/spin.png" class="img-fluid">
                                        </a>
                                    </div>
                                </div>
                                <p class="text-white mt-2">ใช้ <b class="text-warning">{prs.campaign.campaign_total}</b> Point แลกได้ 1 spin</p>
                                
                                
                                
                            </div>
                            
                        </div>
                        {/each}
                    </div>
                    {/if}

                {/if}
            </div>
        </div>
         {#if checkRank}
        <div class="col-12 mt-4" style="text-align: center;">
            <div class="card bg-black mb-2 pt-3 pb-3">
                <div class="col-12"><h6 class="text-white" style="text-align: left !important;padding-left:15px;">เงื่อนไข</h6></div>
                <div class="col-12" style="text-align: left !important;padding-left:15px;color:antiquewhite;">
                    <span>ฝากเงิน <b style="color: gold;">{dataranking.rank_credit.toLocaleString("en-US")}</b> ได้รับ <b style="color: gold;">{dataranking.rank_point} </b> Point</span>
                </div>
                
            </div>
        </div>
         {/if}
         {#if checkRank}
        <div class="col-12 mt-1" style="text-align: center;">
            <div class="card bg-black mb-5 pt-3 pb-3">
                <div class="col-12"><h6 class="text-white" style="text-align: left !important;padding-left:15px;">ประวัติรายการ</h6></div>
                <div class="col-12 row" style="text-align: left !important;padding-left:15px;color:antiquewhite;margin:0px;">
                    {#if isList}
                     {#each cashbackLoglist as datalist, i}
                        <div class="col-4" style="padding: 0px;">{datalist.text}</div>
                        <div class="col-2" style="padding: 0px;text-align:center;">{datalist.win.toLocaleString('th-TH')}</div>
                        <div class="col-6" style="padding: 0px;text-align:center;"> {new Date(datalist.usedDate * 1000).toLocaleString('th-TH')}</div>
                     {/each}
                    {:else}
                    <div class="col-12" style="text-align: center;"><Fa icon={faSpinner} spin /></div>
                    {/if}
                </div>
                
            </div>
        </div>
         {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-promotion">
        <HeaderThemes/>
        <div class="col-12 text-center mt-2" ><h4 class="header-n">กงล้อเสี่ยงโชค</h4></div>
    <div class="col-12" style="min-height: 500px;">
        <div class="col-12 mt-4" style="text-align: center;">
            <div class="card bg-black mb-2 pt-3 pb-3">
                <div class="col-12 text-center"><h6 class="text-white">คุณมี Point คงเหลือ <b style="color: gold;">{myPoint.toLocaleString("en-US")}</b> Point</h6></div>
            </div>
        </div>
        <div class="col-12 mt-2 mb-2" style="text-align: center;">
            <div class="card bg-black"  style="text-align: center;justify-content: center;align-items: center;    background-color: transparent !important;border: 0px;">
                {#if checkRank}
                    {#if checkList}
                    <div class="row">
                        {#each wheelgameList as prs}
                        <div class="col-12 text-cemter p-1">
                            
                            <div class="card bg-black p-2 text-center">
                                <h5 class="text-white">{prs.campaign.campaign_name}</h5>
                                <img src="{prs.campaign.campaign_img}" class="img-fluid" />
                                <h5 class="text-white">คุณมี <b class="text-warning">{prs.spin}</b> spin</h5>
                                <div class="row">
                                    <div class="col-6 ps-3">
                                        
                                        <img src="./assets/images/buyspin.png" class="img-fluid pointer" on:click={() => buyspin(prs.campaign._id)}>
                                        
                                    </div>
                                    
                                    <div class="col-6 pe-3">
                                        <a href="/luckywheel?id={prs.campaign._id}" target="_blank">
                                        <img src="./assets/images/spin.png" class="img-fluid">
                                        </a>
                                    </div>
                                </div>
                                <p class="text-white mt-2">ใช้ <b class="text-warning">{prs.campaign.campaign_total}</b> Point แลกได้ 1 spin</p>
                                
                                
                                
                            </div>
                            
                        </div>
                        {/each}
                    </div>
                    {/if}

                {/if}
            </div>
        </div>
         {#if checkRank}
        <div class="col-12 mt-4" style="text-align: center;">
            <div class="card bg-black mb-2 pt-3 pb-3">
                <div class="col-12"><h6 class="text-white" style="text-align: left !important;padding-left:15px;">เงื่อนไข</h6></div>
                <div class="col-12" style="text-align: left !important;padding-left:15px;color:antiquewhite;">
                    <span>ฝากเงิน <b style="color: gold;">{dataranking.rank_credit.toLocaleString("en-US")}</b> ได้รับ <b style="color: gold;">{dataranking.rank_point} </b> Point</span>
                </div>
                
            </div>
        </div>
         {/if}
         {#if checkRank}
        <div class="col-12 mt-1" style="text-align: center;">
            <div class="card bg-black mb-5 pt-3 pb-3">
                <div class="col-12"><h6 class="text-white" style="text-align: left !important;padding-left:15px;">ประวัติรายการ</h6></div>
                <div class="col-12 row" style="text-align: left !important;padding-left:15px;color:antiquewhite;margin:0px;">
                    {#if isList}
                     {#each cashbackLoglist as datalist, i}
                        <div class="col-4" style="padding: 0px;">{datalist.text}</div>
                        <div class="col-2" style="padding: 0px;text-align:center;">{datalist.win.toLocaleString('th-TH')}</div>
                        <div class="col-6" style="padding: 0px;text-align:center;"> {new Date(datalist.usedDate * 1000).toLocaleString('th-TH')}</div>
                     {/each}
                    {:else}
                    <div class="col-12" style="text-align: center;"><Fa icon={faSpinner} spin /></div>
                    {/if}
                </div>
                
            </div>
        </div>
         {/if}
    </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    /*.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 13rem;
  overflow: hidden;
  height: 3rem;
  background-size: 300% 300%;
  cursor: pointer;
  backdrop-filter: blur(1rem);
  border-radius: 5rem;
  transition: 0.5s;
  animation: gradient_301 5s ease infinite;
  border: double 4px transparent;
  background-image: linear-gradient(#212121, #212121),
    linear-gradient(
      137.48deg,
      #ffdb3b 10%,
      #fe53bb 45%,
      #8f51ea 67%,
      #0044ff 87%
    );
  background-origin: border-box;
  background-clip: content-box, border-box;
}*/

#container-stars {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: 0.5s;
  backdrop-filter: blur(1rem);
  border-radius: 5rem;
}

strong {
  z-index: 2;
  font-family: "Avalors Personal Use";
  font-size: 12px;
  letter-spacing: 5px;
  color: #ffffff;
  text-shadow: 0 0 4px white;
}

#glow {
  position: absolute;
  display: flex;
  width: 12rem;
}

.circle {
  width: 100%;
  height: 30px;
  filter: blur(2rem);
  animation: pulse_3011 4s infinite;
  z-index: -1;
}

.circle:nth-of-type(1) {
  background: rgba(254, 83, 186, 0.636);
}

.circle:nth-of-type(2) {
  background: rgba(142, 81, 234, 0.704);
}

.btn:hover #container-stars {
  z-index: 1;
  background-color: #212121;
}

.btn:hover {
  transform: scale(1.1);
}

.btn:active {
  border: double 4px #fe53bb;
  background-origin: border-box;
  background-clip: content-box, border-box;
  animation: none;
}

.btn:active .circle {
  background: #fe53bb;
}

#stars {
  position: relative;
  background: transparent;
  width: 200rem;
  height: 200rem;
}

#stars::after {
  content: "";
  position: absolute;
  top: -10rem;
  left: -100rem;
  width: 100%;
  height: 100%;
  animation: animStarRotate 90s linear infinite;
}

#stars::after {
  background-image: radial-gradient(#ffffff 1px, transparent 1%);
  background-size: 50px 50px;
}

#stars::before {
  content: "";
  position: absolute;
  top: 0;
  left: -50%;
  width: 170%;
  height: 500%;
  animation: animStar 60s linear infinite;
}

#stars::before {
  background-image: radial-gradient(#ffffff 1px, transparent 1%);
  background-size: 50px 50px;
  opacity: 0.5;
}

@keyframes animStar {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-135rem);
  }
}

@keyframes animStarRotate {
  from {
    transform: rotate(360deg);
  }

  to {
    transform: rotate(0);
  }
}

@keyframes gradient_301 {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

@keyframes pulse_3011 {
  0% {
    transform: scale(0.75);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.75);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

</style>